import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classNames from 'classnames';

import { generateGraphicBannerElement } from 'apps/scribe/scribeContentProvider';

const Banners = ({ betaFeatures, productBanners }) => {
  const shouldShowOnMobileProp = get(productBanners, 'topRhsBannerPage.topBanner.showOnMobile');
  const shouldShowOnMobile = (
    betaFeatures && (betaFeatures.includes('GRAPHIC_BANNERS_ON_MOBILE_FORCE')
      || (
        shouldShowOnMobileProp
        && betaFeatures.includes('GRAPHIC_BANNERS_ON_MOBILE')
      ))
  );

  const bopBannersSectionClassnames = classNames(
    'bop-section',
    'bop-bannerSection',
    { 'show-for-xlarge': !shouldShowOnMobile }
  );

  const topRhsBannerPageExists = productBanners && productBanners.topRhsBannerPage;

  if (!topRhsBannerPageExists) {
    return null;
  }

  return (
    <section className={bopBannersSectionClassnames}>
      {generateGraphicBannerElement(
        topRhsBannerPageExists && productBanners.topRhsBannerPage.topBanner,
        topRhsBannerPageExists
      )}
    </section>
  );
};

Banners.propTypes = {
  betaFeatures: PropTypes.array.isRequired,
  productBanners: PropTypes.object,
};

export default Banners;
